import script from "./FormularioTransferenciaConta.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioTransferenciaConta.vue?vue&type=script&setup=true&lang=js"

import "./FormularioTransferenciaConta.vue?vue&type=style&index=0&id=0e3cafca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3cafca"]])

export default __exports__